/**
 * Token storage. Phase 3 uses localStorage; Phase 4 swaps this for a
 * localforage-backed store alongside the offline mutation queue.
 */
const ACCESS = "th.accessToken";
const REFRESH = "th.refreshToken";

export const tokenStore = {
  get access() {
    return localStorage.getItem(ACCESS);
  },
  get refresh() {
    return localStorage.getItem(REFRESH);
  },
  set({ accessToken, refreshToken }: { accessToken: string; refreshToken: string }) {
    localStorage.setItem(ACCESS, accessToken);
    localStorage.setItem(REFRESH, refreshToken);
  },
  clear() {
    localStorage.removeItem(ACCESS);
    localStorage.removeItem(REFRESH);
  },
};
